module.exports = require("commander");


//////////////////
// WEBPACK FOOTER
// external "commander"
// module id = 59
// module chunks = 0